import checklist from '../../img/get-started/checklist.png';
import hired from '../../img/get-started/hired.png';
import select from '../../img/get-started/select.png';
// import hiring from '../../img/get-started/hiring.png';
// import development from '../../img/get-started/development.png';
import checklistColor from '../../img/get-started/checklist-color.png';
import hiredColor from '../../img/get-started/hired-color.png';
import selectColor from '../../img/get-started/select-color.png';
// import hiringColor from '../../img/get-started/hiring-color.png';
// import developmentColor from '../../img/get-started/development-color.png';

export default [
  {
    id: 'getting-started-1',
    title: 'Fill Out Company Profile',
    desc: `Take the 5-minute Posture Company Profile Assessment to determine the state of your company’s 
    compliance health and get your Compliance Program.`,
    body: `In order for Posture to recommend you with the best frameworks that you'd need to be compliant in,
    you'll need to let us know what your organization is about. Properly fill out your company profile 
    for the best Posture experience.`,
    url: `/app/assessment/company-profile`,
    defaultIcon: checklist,
    colorIcon: checklistColor,
    media: [checklist],
    access: {
      level: 'PostureAdmin',
      msg: 'Contact your Admin to complete this step.'
    }
  },
  {
    id: 'getting-started-2',
    title: 'Invite Your Team',
    desc: `To get tasks done and reach a state of compliance in a timely manner, it's best to have a team.
    Invite your team members and get them on tasks so you can get compliant as quickly as possible.`,
    body: `First, download this template to begin. Fill out the template adding your users, with each row 
    representing a separate user. The column names represent the field for that user. Once you're done
    send your completed template to info@postured.io. We've provided 2 sample users in the file to get you started.`,
    url: `https://s3-us-west-2.amazonaws.com/posture-assets/templates/Posture_Users.csv`,
    defaultIcon: hired,
    colorIcon: hiredColor,
    media: [hired],
    download: true
  },
  {
    id: 'getting-started-3',
    title: 'Execute your HIPAA Playbook',
    desc: `HIPAA requires Covered Entities (CEs) and Business Associates (BAs) to implement policies, procedures, 
    and safeguards to protect the security and privacy of ePHI.  Posture guides you through the process step-by-step.`,
    body: `Click the following link to get started.`,
    url: `/app/playbook/hipaa?mf=open`,
    defaultIcon: select,
    colorIcon: selectColor,
    // gif: '	https://s3-us-west-2.amazonaws.com/posture-assets/gifs/select_frameworks.gif',
  },
  //NOTE: DO NOT REMOVE COMMENTED CODE, IT IS COMMENTED OUT FOR BETA HIPAA USERS
  // {
  //   id: 'getting-started-4',
  //   title: 'Assign Controls and Link Evidence',
  //   desc: `Posture makes it easy to assign controls and link evidence using Agile best practices of the 
  //   whole team approach to gain accountability and visibility within your organization. Complete this step 
  //   by assigning your first control to a team member.`,
  //   body: `In this video, we walk through how you can assign controls to a user and even add evidence. Head 
  //   to a framework page to start assigning controls. Get started by heading to the dashboard, enabling a 
  //   framework and start assigning controls for that framework.`,
  //   url: `/app/dashboard`,
  //   defaultIcon: hiring,
  //   colorIcon: hiringColor,
  //   gif: 'https://s3-us-west-2.amazonaws.com/posture-assets/gifs/assign_controls.gif'
  // },
  // {
  //   id: 'getting-started-5',
  //   title: 'Track Progress on Dashboard',
  //   desc: `Head to the dashboard to view your overall compliance, upcoming controls and general overview of controls
  //   and frameworks.`,
  //   body: `Take a look at this video see what data is available on the dashboard.`,
  //   defaultIcon: development,
  //   colorIcon: developmentColor,
  //   url: `/app/dashboard`,
  //   gif: 'https://s3-us-west-2.amazonaws.com/posture-assets/gifs/track_progress.gif'
  // }
]


// WEBPACK FOOTER //
// ./src/components/get-started/StepData.js